import { h, Component } from 'preact';
import { joinClasses, debounce, accessNested } from 'utils/utils';
import { getShowtimesData } from 'utils/bolt';
import Store from 'store/store';
import s from 'components/bolt/forms/field/field.sss';

export default class Field extends Component {
	constructor(props) {
		super(props);
		this.onKeyDown = debounce(this.onKeyDown.bind(this), 500);
		this.state = {
			errorMessage : ''
		};
		this.validateSelect = this.validateSelect.bind(this);
		this.validateInput = this.validateInput.bind(this);
		this.validateTimepicker = this.validateTimepicker.bind(this);
	}

	onValueChange = () => {
		const { id, onInput } = this.props;
		const elem = this.$element;
		const currentValue = elem.value;
		const validationMessage = this.getValidationMessage('select');
		const regex = new RegExp(this.props.regex);

		if (currentValue && (regex && regex.test(currentValue))) {
			elem.style.color = 'black';
			this.clearClues(elem);
		} else {
			this.showClues(elem, validationMessage);
		}

		onInput?.(id, currentValue);
	}

	getValidationMessage = (type) => {
		const validationMessage = this.props.validationMessage;
		if (!validationMessage) {
			if (type === 'input') {
				return 'Please insert a value';
			} else if (type === 'select') {
				return 'Please select a value';
			} else {
				return 'Please check this field first';
			}
		}

		return validationMessage;
	}

	onKeyDown(e, type) {
		const { id, onInput } = this.props;
		const currentValue = this.$element.value;
		const validationMessage = this.getValidationMessage('input');
		const regex = new RegExp(this.props.regex);

		if (!type) {
			// type text default
			if (currentValue && (regex && !regex.test(currentValue))) {
				this.showClues(this.$element, validationMessage);
			} else {
				this.clearClues(this.$element);
			}

			onInput?.(id, currentValue);
		} else if (type === 'number') {
			const invalidChars = ['-', 'e', '+', 'E'];

			if (invalidChars.some(word => currentValue.includes(word)) || (Number(currentValue) < 2 || Number(currentValue) > 40 )) {
				e.preventDefault();
				this.showClues(this.$element, validationMessage);
				onInput?.(id, '');
			} else {
				this.clearClues(this.$element);
				onInput?.(id, currentValue);
			}

			if (!currentValue) {
				this.$element.value = '';
				this.showClues(this.$element, validationMessage);
			}
		}
	}

	onPaste = (e) => {
		this.setState({ errorMessage: 'Pasting is not allowed' });
		e.preventDefault();
	}

	onTimePickerValueChange = (value, field) => {
		const { id, onInput } = this.props;

		switch (field) {
			case 'hour':
				this.$selectHour.style.color = 'black';
				this.$selectHour.style.outline = '';
				(this.$selectHour?.value && this.$selectMinute?.value && this.$selectMeridian?.value) && this.setState({ errorMessage: '' });
				onInput?.(id, { hour: value, minute: this.$selectMinute.value, meridian: this.$selectMeridian.value });
				break;
			case 'minute':
				this.$selectMinute.style.color = 'black';
				this.$selectMinute.style.outline = '';
				(this.$selectHour?.value && this.$selectMinute?.value && this.$selectMeridian?.value) && this.setState({ errorMessage: '' });
				onInput?.(id, { hour: this.$selectHour.value, minute: value, meridian: this.$selectMeridian.value });
				break;
			case 'meridian':
				this.$selectMeridian.style.color = 'black';
				this.$selectMeridian.style.outline = '';
				(this.$selectHour?.value && this.$selectMinute?.value && this.$selectMeridian?.value) && this.setState({ errorMessage: '' });
				onInput?.(id, { hour: this.$selectHour.value, minute: this.$selectMinute.value, meridian: value });
				break;
		}
	}

	showClues = (elem, validationMessage) => {
		elem.style.outline = '2px solid red';
		elem.style.outlineOffset = '-2px';
		this.setState({ errorMessage: validationMessage });
	}

	clearClues = (elem) => {
		if (elem) {
			elem.style.outline = '';
			this.setState({ errorMessage: '' });
		}
	}

	validateSelect() {
		const validationMessage = this.getValidationMessage('select');
		if (!this.$element.value && this.props.required) {
			this.showClues(this.$element, validationMessage);
		}
	}

	validateTimepicker() {
		const validationMessage = this.getValidationMessage('timepicker');
		// const unfinished = this.$selectMeridian.value || this.$selectHour.value || this.$selectMinute.value;
		const meridian = this.$selectMeridian?.value;
		const hour = this.$selectHour?.value;
		const minute = this.$selectMinute?.value;


		if (!meridian && (this.props.required || (hour || minute))) {
			this.showClues(this.$selectMeridian, validationMessage);
		}
		if (!hour && (this.props.required || (meridian || minute))) {
			this.showClues(this.$selectHour, validationMessage);
		}
		if (!minute && (this.props.required || (meridian || hour))) {
			this.showClues(this.$selectMinute, validationMessage);
		}
	}

	validateInput() {
		const validationMessage = this.getValidationMessage();
		const regex = new RegExp(this.props.regex);

		if (!this.$element.value && this.props.required) {
			this.showClues(this.$element, validationMessage);
		}

		if (this.$element.value && regex && !regex.test(this.$element.value)) {
			this.showClues(this.$element, validationMessage);
		}
	}


	// onFocusOut = (e) => {
	// 	if(e.target.value === ''){
	// 		this.$element.style.outline = "2px solid red";
	// 		this.$element.style.outlineOffset = '-2px';
	// 	}
	// }
	renderTimepicker = (id) => {
		const { nameHour, nameMinutes, nameMeridian, required, value, wrapperClass } = this.props;
		const { errorMessage } = this.state;
		const notes = this.props?.notes;
		const hour = value?.hour;
		const minute = value?.minute;
		const meridian = value?.meridian;


		return 	(
			<div id={id} class={joinClasses(s.wrapper, wrapperClass && wrapperClass)}>
				<div className={s.timepicker}>
					<select className={hour && s.selected} required={required} name={nameHour} ref={ref => this.$selectHour = ref} onInput={(e) => this.onTimePickerValueChange(e.target.value, 'hour')}>
						<option value="" disabled selected={!hour}>Hour</option>
						<option value="1" selected={hour === '1'}>1</option>
						<option value="2" selected={hour === '2'}>2</option>
						<option value="3" selected={hour === '3'}>3</option>
						<option value="4" selected={hour === '4'}>4</option>
						<option value="5" selected={hour === '5'}>5</option>
						<option value="6" selected={hour === '6'}>6</option>
						<option value="7" selected={hour === '7'}>7</option>
						<option value="8" selected={hour === '8'}>8</option>
						<option value="9" selected={hour === '9'}>9</option>
						<option value="10" selected={hour === '10'}>10</option>
						<option value="11" selected={hour === '11'}>11</option>
						<option value="12" selected={hour === '12'}>12</option>
					</select>

					<select className={minute && s.selected} required={required} name={nameMinutes} ref={ref => this.$selectMinute = ref} onInput={(e) => this.onTimePickerValueChange(e.target.value, 'minute')}>
						<option value="" disabled selected={!minute}>Minute</option>
						<option value="00" selected={minute === '00'}>00</option>
						<option value="15" selected={minute === '15'}>15</option>
						<option value="30" selected={minute === '30'}>30</option>
						<option value="45" selected={minute === '45'}>45</option>
					</select>

					<select className={meridian && s.selected} required={required} name={nameMeridian} ref={ref => this.$selectMeridian = ref} onInput={(e) => this.onTimePickerValueChange(e.target.value, 'meridian')}>
						<option disabled selected={!meridian} value="">AM/PM</option>
						<option selected={meridian === 'AM'} value="AM">AM</option>
						<option selected={meridian === 'PM'} value="PM">PM</option>
					</select>

				</div>
				{errorMessage && <div className={s.errorText}>{errorMessage}</div>}
				{notes && <div className={s.notesText}>{notes}</div>}
			</div>
		);
	}

	renderDatepicker = () => {
		const { id, value, placeholder, required, disabled, class:extraClass, wrapperClass, noBg, onInput } = this.props;
		const { errorMessage } = this.state;
		const notes = this.props?.notes;
		const store = Store.get();
		const showtimeData = accessNested(store, 'showtimes.data');

		const isCinemark = showtimeData.some(item => item.chain.slug === 'cinemark-theatres');

		const today = new Date();
		const minDate = new Date(today.setDate(today.getDate() + 14));
		const in14Days = minDate.toISOString().split('T')[0];
		const selectedDate = value ? new Date(value) : null; // Parse the current value into a date if it exists (there might be a better way to do this)
		const use14DaysDefault = !selectedDate || selectedDate < minDate; // If there is a selected date, check if it's less than 14 days from today

		// ! Do not add a name property
		// Not adding name so it doesn't get submitted. This field is meant only for collecting the date,
		// the real date field is rendered in hidden fields, to adhere to different date collection of different chains.

		return 	(
			<div className={joinClasses(s.wrapper, wrapperClass && wrapperClass)}>
				{/* onBlur={e => this.onFocusOut(e)} */}
				<input
					id={id}
					value={isCinemark && use14DaysDefault ? in14Days : value}
					className={joinClasses(extraClass, value && s.selected, noBg && s.noBg)}
					type="date"
					required={required}
					placeholder={placeholder}
					disabled={disabled}
					ref={ref => this.$element = ref}
					onKeyDown={(e) => this.props.onKeyDown && this.onKeyDown(e, 'input')}
					onPaste={e => this.onPaste(e)}
					onInput={onInput && this.onValueChange}
					min={isCinemark ? in14Days : undefined}
				/>
				{errorMessage && <div className={s.errorText}>{errorMessage}</div>}
				{notes && <div className={s.notesText}>{notes}</div>}
			</div>
		);
	}

	render() {
		const { id, name, options, value, placeholder, type, subtype, required, disabled, label, class:extraClass, wrapperClass, noBg, labelAlike, onInput, plainText } = this.props;
		const { errorMessage } = this.state;
		const notes = this.props?.notes;

		if (type === 'select') {
			return 	(
				<div class={joinClasses(s.wrapper, s.selectWrapper, wrapperClass && wrapperClass)}>
					<select id={id} required={required} name={name} ref={ref => this.$element = ref} onInput={this.onValueChange} className={value && s.selected}>
						<option value="" disabled selected={!value}>{placeholder}</option>
						{options.map(option => 	{
							let newValue = option;
							// quick hack to address their backend late validation
							if (this.props.formId === 'regal-cinemas' && this.props.name === 'StateName') {
								const regExp = /\(([^)]+)\)/; // get everything between ()
								newValue = regExp.exec(option)[1];
							}
							return <option value={newValue} selected={value === option}>{option}</option>;
						})}
					</select>
					{errorMessage && <div className={s.errorText}>{errorMessage}</div>}
					{notes && <div className={s.notesText}>{notes}</div>}
				</div>
			);
		}

		if (type === 'datepicker') {
			return this.renderDatepicker(id);
		}

		if (type === 'timepicker') {
			return this.renderTimepicker(id);
		}

		if (type === 'textarea') {
			return 	(
				<div className={joinClasses(s.wrapper, wrapperClass && wrapperClass)}>
					<textarea id={id} ref={ref => this.$element = ref} value={value} className={value && s.selected} type={subtype} required={required} onPaste={this.onPaste} placeholder={placeholder} disabled={disabled} name={name} onKeyDown={(e) => this.onKeyDown(e, subtype)} />
					{errorMessage && <div className={s.errorText}>{errorMessage}</div>}
					{notes && <div className={s.notesText}>{notes}</div>}
				</div>
			);
		}

		if (type === 'paragraph') {
			return (
				<div class={joinClasses(s.wrapper, s.paragraph, labelAlike && s.labelAlike, plainText && s.plainText, wrapperClass && wrapperClass)}>
					<p>
						<span className={s.label}>{label}</span>
						<span className={s.value}>{value}</span>
						{this.props.icon && <span className={s.iconRight}>{this.props.icon}</span>}
					</p>
				</div>
			);
		}

		return 	(
			<div className={joinClasses(s.wrapper, wrapperClass && wrapperClass)}>
				{/* onBlur={e => this.onFocusOut(e)} */}
				<input
					id={id}
					name={name}
					value={value}
					className={joinClasses(extraClass, value && s.selected, noBg && s.noBg)}
					type={subtype}
					required={required}
					placeholder={placeholder}
					disabled={disabled}
					ref={ref => this.$element = ref}
					onKeyDown={(e) => this.props.onKeyDown && this.onKeyDown(e, subtype)}
					onPaste={e => this.onPaste(e)}
					onInput={onInput && this.onValueChange}
				/>
				{errorMessage && <div className={s.errorText}>{errorMessage}</div>}
				{notes && <div className={s.notesText}>{notes}</div>}
			</div>
		);
	}
}